// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1PBV1","title":"ClientReferral_title__1SvKF","itemText":"ClientReferral_itemText__35FVu"};